import React, { useState, useRef } from 'react';
import Lottie from "lottie-react";
import passwordLockAnimation from '../../../assests/images/Animations/passwordLock.json'; // Path to your Lottie animation
import { TextField, IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import loginStyles from '../../../pages/Login/Login.module.scss';

const cx = (...names) => names.filter(Boolean).map((n) => loginStyles[n]).filter(Boolean).join(' ');

const ResetPassword = ({ t, isRTL, password, setPassword, reEnterPassword,setReEnterPassword,handleResetPassword,handleInputChange }) => {
  const [hasError, setHasError] = useState(false);
  const inputs = useRef([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);



  return (
    <div className={cx('verify-otp-container')}>
      <div className={cx('animations-container')}>
        <Lottie
          animationData={passwordLockAnimation}
          loop
          style={{ width: '100%', height: 'auto' }}
        />
      </div>
      <div className={cx('login-input-container')} style={{ width: '100%' }}>
        <div className={cx('login-input-label')}>
          {t('enterNewPassword')}
        </div>
        <TextField
          fullWidth
          placeholder={t('enterNewPassword')}
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={handleInputChange(setPassword)}
          className={cx('style-input', 'password-input')}
          variant="standard"
          InputProps={{
            disableUnderline: true,
            className: `custom-input-box-sizing ${!isRTL ? 'ltr-input' : 'rtl-input'}`,
            endAdornment: (
              <InputAdornment style={{ boxSizing: 'border-box' }} position={!isRTL ? 'end' : 'start'}>
                <IconButton
                  onClick={() => setShowPassword((prev) => !prev)}
                  edge={!isRTL ? 'end' : 'start'}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div className={cx('login-input-container')} style={{ width: '100%' }}>
        <div className={cx('login-input-label')}>
          {t('reEnterPassword')}
        </div>
        <TextField
          fullWidth
          placeholder={t('reEnterPassword')}
          type={showRePassword ? 'text' : 'password'}
          value={reEnterPassword}
          onChange={handleInputChange(setReEnterPassword)}
          className={cx('style-input', 'password-input')}
          variant="standard"
          InputProps={{
            disableUnderline: true,
            className: `custom-input-box-sizing ${!isRTL ? 'ltr-input' : 'rtl-input'}`,
            endAdornment: (
              <InputAdornment style={{ boxSizing: 'border-box' }} position={!isRTL ? 'end' : 'start'}>
                <IconButton
                  onClick={() => setShowRePassword((prev) => !prev)}
                  edge={!isRTL ? 'end' : 'start'}
                >
                  {showRePassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>


      <button className={cx('login-button')} onClick={handleResetPassword}>{t('verify code')}</button>



    </div>
  );
};

export default ResetPassword;
